import { axios, base, LONG_REQUEST_TIMEOUT } from '../http';

export const getSemesterList = (params) => {
  return axios.get(`${base}/api/Common/GetSemesterList`, {
    params: params
  }).then(res => res.data);
};

// 就餐时间�?

export const getTemperatureRangeListPage = (params) => {
  return axios.get(`${base}/api/TemperatureRange/get`, { params: params });
};

export const editTemperatureRange = (params) => {
  return axios.put(`${base}/api/TemperatureRange/put`, params);
};

export const getDeptTemperatureRecordsPage = (params) => {
  return axios.get(`${base}/api/TemperatureRecord/GetDeptRecords`, {
    params: params,
  });
};

export const getTemperatureHistory = (params) => {
  return axios.get(`${base}/api/TemperatureRecord/GetTemperatureHistory`, {
    params: params,
  });
};

export const getTemperatureDeptDailyDetail = (params) => {
  return axios.get(`${base}/api/TemperatureRecord/GetDeptDailyDetail`, {
    params: params,
  });
};

//导出部门每日测温汇�?

export const exportTemperatureDeptDailyDetail = (params) => {
  return axios.get(`${base}/api/TemperatureRecord/ExportDeptDailyDetail`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//获取未测温人员列�?

export const getTempNewsList = (params) => {
  return axios.get(`${base}/api/NoticeRecord/GetTempNewsList`, {
    params: params,
  });
};

//手动获取临时信息列表

export const fetchSchoolNews = (params) => {
  return axios.get(`${base}/api/job/fetchSchoolNews`, { params: params });
};

//删除临时信息

export const deleteTempNews = (params) => {
  return axios.delete(`${base}/api/NoticeRecord/DeleteTempNews`, {
    params: params,
  });
};

/**
 * 统计可按条件清除的临时新闻条数
 * @param {Object} params - { departmentId, beforeTime, onlyUnchecked }
 */
export const countClearableTempNews = (params) => {
  return axios.get(`${base}/api/NoticeRecord/CountClearableTempNews`, {
    params: params,
  });
};

/**
 * 按条件批量清除临时新闻（部门 + 截止时间 + 是否仅未审核）
 * @param {Object} data - { DepartmentId, BeforeTime, OnlyUnchecked }
 */
export const clearOverdueTempNews = (data) => {
  return axios.post(`${base}/api/NoticeRecord/ClearOverdueTempNews`, data);
};

//审核临时新闻并发布为公告

export const auditAndPublishTempNews = (params) => {
  return axios.post(`${base}/api/NoticeRecord/AuditAndPublishTempNews`, params);
};

//根据部门获取审批�?

export const getAuditorsByDepartment = (params) => {
  return axios.get(`${base}/api/NoticeRecord/GetAuditorsByDepartment`, {
    params: params,
  });
};

/**
 * 获取临时新闻审核配置（是否会签）
 * @param {Object} params - { departmentId }
 */
export const getTempNewsAuditConfig = (params) => {
  return axios.get(`${base}/api/NoticeRecord/GetTempNewsAuditConfig`, {
    params: params,
  });
};

//保存审批人

export const saveAuditor = (params) => {
  return axios.post(`${base}/api/NoticeRecord/SaveAuditor`, params);
};

//获取公告记录

export const getNoticeRecordListPage = (params) => {
  return axios.get(`${base}/api/NoticeRecord/get`, { params: params });
};
//编辑公告

export const editNoticeRecord = (params) => {
  return axios.put(`${base}/api/NoticeRecord/put`, params);
};
//新增公告

export const addNoticeRecord = (params) => {
  return axios.post(`${base}/api/NoticeRecord/post`, params);
};
//删除公告

export const deleteNoticeRecord = (params) => {
  return axios.delete(`${base}/api/NoticeRecord/Delete`, { params: params });
};

//退�?

export const addSchoolBusPassenger = (params) => {
  return axios.post(`${base}/api/SchoolBusPassenger/post`, params);
};

export const getSchoolBusPassenger = (params) => {
  return axios.get(`${base}/api/SchoolBusPassenger/get`, { params: params });
};

export const removeSchoolBusPassenger = (params) => {
  return axios.delete(`${base}/api/SchoolBusPassenger/delete`, {
    params: params,
  });
};

//校车刷卡记录
//部门校车记录

export const getDeptSchoolBusRecords = (params) => {
  return axios.get(`${base}/api/SchoolBus/GetDeptSchoolBusRecords`, {
    params: params,
  });
};

// 导出部门校车记录

export const exportDeptSchoolBusRecords = (params) => {
  return axios.get(`${base}/api/SchoolBus/ExportDeptSchoolBusRecords`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

export const getetSchoolBusRecords = (params) => {
  return axios.get(`${base}/api/SchoolBus/GetSchoolBusRecords`, {
    params: params,
  });
};

export const getSchoolBusPickRecords = (params) => {
  return axios.get(`${base}/api/SchoolBus/GetSchoolBusPickRecords`, {
    params: params,
  });
};

// 导出校车接送记�?

export const exportSchoolBusPickRecords = (params) => {
  return axios.get(`${base}/api/SchoolBus/ExportSchoolBusPickRecords`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

// 宿舍楼管�?

export const getfloorsListPage = (params) => {
  return axios.get(`${base}/api/Floors/get`, { params: params });
};

export const removefloors = (params) => {
  return axios.delete(`${base}/api/Floors/delete`, { params: params });
};

/** 批量删除楼层 */
export const batchDeleteFloors = (params) => {
  return axios.post(`${base}/api/Floors/BatchDelete`, params);
};

export const editfloors = (params) => {
  return axios.put(`${base}/api/Floors/put`, params);
};

export const addfloors = (params) => {
  return axios.post(`${base}/api/Floors/post`, params);
};

export const getfloorsList = (params) => {
  return axios.get(`${base}/api/Floors/GetList`, { params: params });
};
//房间

export const getroomsListPage = (params) => {
  return axios.get(`${base}/api/Rooms/get`, { params: params });
};

export const removerooms = (params) => {
  return axios.delete(`${base}/api/Rooms/delete`, { params: params });
};

export const editrooms = (params) => {
  return axios.put(`${base}/api/Rooms/put`, params);
};

export const addrooms = (params) => {
  return axios.post(`${base}/api/Rooms/post`, params);
};

//考勤大屏

export const getTemperatureRuleListPage = (params) => {
  return axios.get(`${base}/api/TemperatureRule/get`, { params: params });
};

export const getTemperatureRuleList = (params) => {
  return axios.get(`${base}/api/TemperatureRule/GetList`, { params: params });
};

export const removeTemperatureRule = (params) => {
  return axios.delete(`${base}/api/TemperatureRule/delete`, { params: params });
};

export const editTemperatureRule = (params) => {
  return axios.put(`${base}/api/TemperatureRule/put`, params);
};

export const addTemperatureRule = (params) => {
  return axios.post(`${base}/api/TemperatureRule/post`, params);
};

// 宿舍考勤规则信息模块

// 宿舍考勤排班各天设置�?

// 宿舍考勤记录查看

//宿舍考勤统计

/** 宿舍考勤时段下拉（当前时段排最前） */
//宿舍考勤打卡、未打卡�?

// 请假类型

export const getLeaveTypeListPage = (params) => {
  return axios.get(`${base}/api/LeaveType/get`, { params: params });
};

export const getLeaveTypeList = (params) => {
  return axios.get(`${base}/api/LeaveType/GetList`, { params: params });
};

export const removeLeaveType = (params) => {
  return axios.delete(`${base}/api/LeaveType/delete`, { params: params });
};

export const editLeaveType = (params) => {
  return axios.put(`${base}/api/LeaveType/put`, params);
};

export const addLeaveType = (params) => {
  return axios.post(`${base}/api/LeaveType/post`, params);
};

// 审批定义�?

export const getLeaveApprovalProcessListPage = (params) => {
  return axios.get(`${base}/api/LeaveApprovalProcess/get`, { params: params });
};

export const removeLeaveApprovalProcess = (params) => {
  return axios.delete(`${base}/api/LeaveApprovalProcess/delete`, {
    params: params,
  });
};

export const editLeaveApprovalProcess = (params) => {
  return axios.put(`${base}/api/LeaveApprovalProcess/put`, params);
};

// 从指定学生名单移除一人（学生档案已删除时也可移除）
export const removeLeaveApprovalProcessStudent = (params) => {
  return axios.post(`${base}/api/LeaveApprovalProcess/RemoveProcessStudent`, params);
};

export const addLeaveApprovalProcess = (params) => {
  return axios.post(`${base}/api/LeaveApprovalProcess/post`, params);
};

//获取审批人员

export const getProcessOfficer = (params) => {
  return axios.get(`${base}/api/LeaveApprovalProcess/GetProcessOfficer`, {
    params: params,
  });
};

//新增审批人员

export const addProcessOfficer = (params) => {
  return axios.post(
    `${base}/api/LeaveApprovalProcess/AddProcessOfficer`,
    params,
  );
};

//查询请假通过抄送人�?

export const getProcessCc = (params) => {
  return axios.get(`${base}/api/LeaveApprovalProcess/GetProcessCc`, {
    params: params,
  });
};

//保存请假通过抄送人�?

export const saveProcessCc = (params) => {
  return axios.post(`${base}/api/LeaveApprovalProcess/SaveProcessCc`, params);
};

export const getRepairCompletionCc = (params) => {
  return axios.get(`${base}/api/LeaveApprovalProcess/GetRepairCompletionCc`, { params });
};

export const saveRepairCompletionCc = (params) => {
  return axios.post(`${base}/api/LeaveApprovalProcess/SaveRepairCompletionCc`, params);
};

export const deleteRepairProcessesBySchool = (departmentId) => {
  return axios.delete(`${base}/api/LeaveApprovalProcess/DeleteRepairBySchool`, {
    params: { departmentId }
  });
};

export const getSchoolBusPassengerListPage = (params) => {
  return axios.get(`${base}/api/SchoolBus/GetSchoolBusPassenger`, {
    params: params,
  });
};

// 水电控设备参数配置表

export const getDeptScreenSaverMessageListPage = (params) => {
  return axios.get(`${base}/api/DeptScreenSaverMessage/get`, {
    params: params,
  });
};
//编辑班级屏保

export const editDeptScreenSaverMessage = (params) => {
  return axios.put(`${base}/api/DeptScreenSaverMessage/put`, params);
};
//新增班级屏保

export const addDeptScreenSaverMessage = (params) => {
  return axios.post(`${base}/api/DeptScreenSaverMessage/post`, params);
};
//删除班级屏保

export const deleteDeptScreenSaverMessage = (params) => {
  return axios.delete(`${base}/api/DeptScreenSaverMessage/Delete`, {
    params: params,
  });
};

//获取班级通知

export const getDeptNoticeRecordListPage = (params) => {
  return axios.get(`${base}/api/DeptNoticeRecord/get`, { params: params });
};
//编辑班级通知

export const editDeptNoticeRecord = (params) => {
  return axios.put(`${base}/api/DeptNoticeRecord/put`, params);
};
//新增班级通知

export const addDeptNoticeRecord = (params) => {
  return axios.post(`${base}/api/DeptNoticeRecord/post`, params);
};
//删除班级通知

export const deleteDeptNoticeRecord = (params) => {
  return axios.delete(`${base}/api/DeptNoticeRecord/Delete`, {
    params: params,
  });
};

//获取班级风采

export const getDeptStyleRecordListPage = (params) => {
  return axios.get(`${base}/api/DeptStyleRecord/get`, { params: params });
};
//编辑班级风采

export const editDeptStyleRecord = (params) => {
  return axios.put(`${base}/api/DeptStyleRecord/put`, params);
};
//新增班级风采

export const addDeptStyleRecord = (params) => {
  return axios.post(`${base}/api/DeptStyleRecord/post`, params);
};
//删除班级风采

export const deleteDeptStyleRecord = (params) => {
  return axios.delete(`${base}/api/DeptStyleRecord/Delete`, { params: params });
};

//获取班级视频

export const getDeptVideoRecordListPage = (params) => {
  return axios.get(`${base}/api/DeptVideoRecord/get`, { params: params });
};
//编辑班级视频

export const editDeptVideoRecord = (params) => {
  return axios.put(`${base}/api/DeptVideoRecord/put`, params);
};
//新增班级视频

export const addDeptVideoRecord = (params) => {
  return axios.post(`${base}/api/DeptVideoRecord/post`, params);
};
//删除班级视频

export const deleteDeptVideoRecord = (params) => {
  return axios.delete(`${base}/api/DeptVideoRecord/Delete`, { params: params });
};

/**
 * 是否开启本校视频 OSS 直传（schoolId 支持 sch_100 或部门数字 Id）。最后更新：2026-05-25
 */

export const isVideoDirectUploadEnabled = (schoolId) => {
  return axios.get(`${base}/api/OssVideoUpload/IsVideoDirectUploadEnabled`, {
    params: { schoolId },
  });
};

/**
 * 获取视频 OSS 直传 STS 临时凭证与 objectKey（提交保存前由前端直传 OSS）。最后更新：2026-05-25
 */

export const getVideoUploadCredential = (params) => {
  return axios.get(`${base}/api/OssVideoUpload/GetVideoUploadCredential`, {
    params,
  });
};

/**
 * 获取本校 OSS 媒体临时读 URL（预签名，私有 Bucket 播放用）。
 * params: { schoolId, url } — url 为库中存的 HTTPS 对象地址。最后更新：2026-05-25
 */

export const getOssVideoPlayUrl = (params) => {
  return axios.get(`${base}/api/OssVideoUpload/GetOssVideoPlayUrl`, {
    params,
  });
};

/**
 * 单条 OSS 媒体临时读 URL（预签名）。最后更新：2026-07-01
 */

export const getMediaReadUrl = (params) => {
  return axios.get(`${base}/api/OssMediaUpload/GetMediaReadUrl`, {
    params,
  });
};

/**
 * 批量 OSS 媒体临时读 URL。body: { schoolId, urls, inline }
 */

export const getMediaReadUrls = (data) => {
  return axios.post(`${base}/api/OssMediaUpload/GetMediaReadUrls`, data);
};

//获取荣誉类型

export const getSemesterSettingListPage = (params) => {
  return axios.get(`${base}/api/SemesterSetting/get`, { params: params });
};
//编辑学期课程配置

export const editSemesterSetting = (params) => {
  return axios.put(`${base}/api/SemesterSetting/put`, params);
};
//新增学期课程配置

export const addSemesterSetting = (params) => {
  return axios.post(`${base}/api/SemesterSetting/post`, params);
};
//删除学期课程配置

export const deleteSemesterSetting = (params) => {
  return axios.delete(`${base}/api/SemesterSetting/Delete`, { params: params });
};
// 获取值周配置

export const getWeeklyDutySettings = (params) => {
  return axios.get(
    `${base}/api/SemesterSetting/GetSemesterDutyWeeksBySemesterId`,
    { params: params },
  );
};

//只更新已有的学期值周人员信息

export const saveSemesterDutyWeeks = (params) => {
  return axios.post(
    `${base}/api/SemesterSetting/SaveSemesterDutyWeeks`,
    params,
  );
};

//获取教学科目管理

export const getDutyStaffListPage = (params) => {
  return axios.get(`${base}/api/DutyStaff/GetList`, { params: params });
};
// 获取课表管理员分页列表

export const getScheduleAdminListPage = (params) => {
  return axios.get(`${base}/api/ScheduleAdmin/GetList`, { params: params });
};
// 获取课表管理员（审批权限）

export const getScheduleAdminsForApproval = (params) => {
  return axios.get(`${base}/api/ScheduleAdmin/GetScheduleAdmins`, { params: params });
};
// 新增课表管理员

export const addScheduleAdmin = (params) => {
  return axios.post(`${base}/api/ScheduleAdmin/Add`, params);
};
// 编辑课表管理员

export const editScheduleAdmin = (params) => {
  return axios.post(`${base}/api/ScheduleAdmin/Edit`, params);
};
// 删除课表管理员

export const removeScheduleAdmin = (params) => {
  return axios.post(`${base}/api/ScheduleAdmin/Delete`, null, { params: params });
};

// 班级点到 - 时段配置

export const getClassRollCallTimeSlotList = (params) => {
  return axios.get(`${base}/api/ClassRollCallTimeSlot/GetList`, { params });
};

export const saveClassRollCallTimeSlot = (params) => {
  return axios.post(`${base}/api/ClassRollCallTimeSlot/Save`, params);
};

export const setClassRollCallTimeSlotEnabled = (params) => {
  return axios.post(`${base}/api/ClassRollCallTimeSlot/SetEnabled`, null, { params });
};

// 班级点到 - 管理员

export const getClassRollCallPrivAdminListPage = (params) => {
  return axios.get(`${base}/api/ClassRollCallPrivAdmin/GetList`, { params });
};

export const addClassRollCallPrivAdmin = (params) => {
  return axios.post(`${base}/api/ClassRollCallPrivAdmin/Add`, params);
};

export const editClassRollCallPrivAdmin = (params) => {
  return axios.post(`${base}/api/ClassRollCallPrivAdmin/Edit`, params);
};

export const removeClassRollCallPrivAdmin = (params) => {
  return axios.post(`${base}/api/ClassRollCallPrivAdmin/Delete`, null, { params });
};

// 班级点到 - 统计与导出

export const getClassRollCallStatistics = (params) => {
  return axios.get(`${base}/api/ClassRollCallStats/GetStatistics`, { params });
};
/** 管理端：按班级+考勤日+时段取会话详情（含 sessionId，供报表补解析） */

export const getClassRollCallClassDetail = (params) => {
  return axios.get(`${base}/api/ClassRollCallStats/GetClassDetail`, { params });
};

export const addDutyStaff = (params) => {
  return axios.post(`${base}/api/DutyStaff/Add`, params);
};

export const editDutyStaff = (params) => {
  return axios.post(`${base}/api/DutyStaff/Edit`, params);
};

export const removeDutyStaff = (params) => {
  return axios.post(`${base}/api/DutyStaff/Delete`, null, { params: params });
};

/** 德育商城管理员（管理端） */

export const getClassPrizeListForAdmin = (params) => {
  return axios.get(`${base}/api/ClassPrizeAdmin/GetList`, { params: params });
};

export const saveClassPrizeForAdmin = (data) => {
  return axios.post(`${base}/api/ClassPrizeAdmin/Save`, data);
};

export const updateClassPrizeShelfForAdmin = (data) => {
  return axios.post(`${base}/api/ClassPrizeAdmin/UpdateShelf`, data);
};

export const deleteClassPrizeForAdmin = (params) => {
  return axios.post(`${base}/api/ClassPrizeAdmin/Delete`, null, { params: params });
};

export const getClassPrizeExchangeRecords = (params) => {
  return axios.get(`${base}/api/ClassPrizeAdmin/GetExchangeRecords`, { params: params });
};

export const revokeClassPrizeExchangeRecord = (data) => {
  return axios.post(`${base}/api/ClassPrizeAdmin/RevokeExchange`, data);
};

// 奖品兑换记录汇总（班级/校级 Tab）

export const getCampusList = (params) => {
  return axios.get(`${base}/api/Campus/GetList`, { params: params });
};

export const getAccessControlRuleListPage = (params) => {
  return axios.get(`${base}/api/AccessControlRule/get`, { params: params });
};
//新增门禁规则

export const addAccessControlRule = (params) => {
  return axios.post(`${base}/api/AccessControlRule/post`, params);
};
//编辑门禁规则

export const editAccessControlRule = (params) => {
  return axios.put(`${base}/api/AccessControlRule/put`, params);
};
//删除门禁规则

export const deleteAccessControlRule = (params) => {
  return axios.delete(`${base}/api/AccessControlRule/Delete`, {
    params: params,
  });
};

/** 门禁规则：根据人员 ID 列表批量查询人员名称及身份类型。创建于 2026-09-08 */
export const getAccessControlPersonsByIds = (ids) => {
  return axios.post(`${base}/api/AccessControlRule/GetPersonsByIds`, ids);
};

/** 门禁临时规则：分页列表。创建于 2026-10-12 */
export const getAccessTempRuleListPage = (params) => {
  return axios.get(`${base}/api/AccessControlTempRule/Get`, { params });
};

/** 门禁临时规则：新增/编辑（Id=0 为新增）。创建于 2026-10-12 */
export const saveAccessTempRule = (params) => {
  return axios.post(`${base}/api/AccessControlTempRule/Save`, params);
};

/** 门禁临时规则：删除（已在天波时先从天波删除）。创建于 2026-10-12 */
export const deleteAccessTempRule = (params) => {
  return axios.delete(`${base}/api/AccessControlTempRule/Delete`, { params });
};

/** 门禁临时规则：立即下发天波。创建于 2026-10-12 */
export const pushAccessTempRuleNow = (params) => {
  return axios.post(`${base}/api/AccessControlTempRule/PushNow`, null, { params });
};

/** 门禁临时规则：提前结束（立即从天波删除）。创建于 2026-10-12 */
export const finishAccessTempRuleNow = (params) => {
  return axios.post(`${base}/api/AccessControlTempRule/FinishNow`, null, { params });
};

//查询补贴用户

export const getClassExtensionInfoListPage = (params) => {
  return axios.get(`${base}/api/ClassExtensionInfo/get`, { params: params });
};
//新增班级扩展信息

export const addClassExtensionInfo = (params) => {
  return axios.post(`${base}/api/ClassExtensionInfo/post`, params);
};
//编辑班级扩展信息

export const editClassExtensionInfo = (params) => {
  return axios.put(`${base}/api/ClassExtensionInfo/put`, params);
};
//删除班级扩展信息

export const deleteClassExtensionInfo = (params) => {
  return axios.delete(`${base}/api/ClassExtensionInfo/Delete`, {
    params: params,
  });
};

//查询自定义组

export const getCustomComponentList = (params) => {
  return axios.get(`${base}/api/CustomComponent/get`, { params: params });
};
//新增自定义组

export const addCustomComponent = (params) => {
  return axios.post(`${base}/api/CustomComponent/post`, params);
};

//删除自定义组

export const deleteCustomComponent = (params) => {
  return axios.delete(`${base}/api/CustomComponent/Delete`, { params: params });
};

//获取首页数据

export const getHomePage = (params) => {
  return axios.get(`${base}/api/CustomComponent/GetHomePage`, {
    params: params,
  });
};

//获取首页数据列表

export const GetHomePageList = (params) => {
  return axios.get(`${base}/api/CustomComponent/GetHomePageList`, {
    params: params,
  });
};

//保存或编辑自定义首页（有Id为编辑，无Id为新增）

export const saveHomePage = (params) => {
  return axios.post(`${base}/api/CustomComponent/SaveHomePage`, params);
};

// 绑定首页到班牌终�?

export const BindKqTerminalHomePage = (params) => {
  return axios.post(
    `${base}/api/CustomComponent/BindKqTerminalHomePage`,
    params,
  );
};

//删除自定义模�?

export const DeleteHomePage = (params) => {
  return axios.delete(`${base}/api/CustomComponent/DeleteHomePage`, {
    params: params,
  });
};

//查询班级作业信息

export const getHomeworkList = (params) => {
  return axios.get(`${base}/api/ClassHomeWork/get`, { params: params });
};
//新增班级作业信息

export const addHomework = (params) => {
  return axios.post(`${base}/api/ClassHomeWork/post`, params);
};
//编辑班级作业信息

export const editHomework = (params) => {
  return axios.put(`${base}/api/ClassHomeWork/put`, params);
};
//删除班级作业信息

export const deleteHomework = (params) => {
  return axios.delete(`${base}/api/ClassHomeWork/Delete`, { params: params });
};

//获取班级作业汇总（H5用）

export const getClassWorkSummary = (params) => {
  return axios.get(`${base}/api/ClassHomeWork/GetClassWorkSummary`, {
    params: params,
  });
};

//查询定时开关机记录

export const batchDeviceCmd = (params) => {
  return axios.post(`${base}/api/Cplate/BatchDeviceCmd`, params);
};

//获取考场列表

export const getLeaveRequestByDepartment = (params) => {
  return axios.get(`${base}/api/Leave/GetLeaveRequestByDepartment`, {
    params: params,
  });
};

//获取请假统一报表

export const getUnifiedLeaveRequestByDepartment = (params) => {
  return axios.get(`${base}/api/Leave/GetUnifiedLeaveRequestByDepartment`, {
    params: params,
  });
};

//获取代请假申请记�?

export const getAgentLeaveRequestByDepartment = (params) => {
  return axios.get(`${base}/api/Leave/GetAgentLeaveRequestByDepartment`, {
    params: params,
  });
};

// 请假门禁同步任务汇总
export const getLeaveTbSyncSummary = () => {
  return axios.get(`${base}/api/Leave/GetLeaveTbSyncSummary`);
};

// 请假门禁同步任务列表
export const getLeaveTbSyncTasks = (params) => {
  return axios.get(`${base}/api/Leave/GetLeaveTbSyncTasks`, {
    params: params,
  });
};

// 重试请假门禁同步任务
export const retryLeaveTbSyncTask = (params) => {
  return axios.post(`${base}/api/Leave/RetryLeaveTbSyncTask`, null, {
    params: params,
  });
};

//删除代请假申请记�?

export const deleteAgentLeaveRequests = (params) => {
  return axios.delete(`${base}/api/Leave/DeleteAgentLeaveRequests`, {
    params: params,
  });
};

//批量导入请假申请记录

export const batchImportLeaveRequests = (params) => {
  return axios.post(`${base}/api/Leave/BatchImportLeaveRequests`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

//删除请假申请记录

export const deleteLeaveRequests = (params) => {
  return axios.delete(`${base}/api/Leave/DeleteLeaveRequests`, {
    params: params,
  });
};

//导出请假申请记录

export const exportLeaveRequestByDepartment = (params) => {
  return axios.get(`${base}/api/Leave/ExportLeaveRequestByDepartment`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//导出代请假申请记�?

export const exportAgentLeaveRequestByDepartment = (params) => {
  return axios.get(`${base}/api/Leave/ExportAgentLeaveRequestByDepartment`, {
    params: params,
    responseType: "blob", // 指定响应类型?blob
  });
};

//导出统一请假报表

export const exportUnifiedLeaveRequestByDepartment = (params) => {
  return axios.get(`${base}/api/Leave/ExportUnifiedLeaveRequestByDepartment`, {
    params: params,
    responseType: "blob", // 指定响应类型?blob
  });
};

//删除统一请假申请记录

export const deleteUnifiedLeaveRequests = (params) => {
  return axios.post(`${base}/api/Leave/DeleteUnifiedLeaveRequests`, params);
};

/** 检查请假主表与审批环节状态不一致的记录。最后更新：2026-09-01 */
export const getLeaveStatusAnomalies = (params) => {
  return axios.get(`${base}/api/Leave/GetLeaveStatusAnomalies`, { params });
};

/** 修复单条请假状态异常 */
export const fixLeaveStatusAnomaly = (params) => {
  return axios.post(`${base}/api/Leave/FixLeaveStatusAnomaly`, params);
};

/** 批量修复请假状态异常 */
export const fixLeaveStatusAnomalies = (params) => {
  return axios.post(`${base}/api/Leave/FixLeaveStatusAnomalies`, params);
};

//获取返校申请记录

export const getReturnSchoolApplicationPage = (params) => {
  return axios.get(`${base}/api/Leave/GetReturnSchoolApplicationPage`, {
    params: params,
  });
};

//导出返校申请记录

export const exportReturnSchoolApplication = (params) => {
  return axios.get(`${base}/api/Leave/ExportReturnSchoolApplication`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//获取考试列表

export const getPushNotificationListPage = (params) => {
  return axios.get(`${base}/api/Values/GetPushNotificationList`, {
    params: params,
  });
};

/** 获取推送日志详情，并按需刷新钉钉发送结果 */
export const getPushNotificationDetail = (params) => {
  return axios.get(`${base}/api/Values/GetPushNotificationDetail`, {
    params: params,
  });
};

// 获取部门值日检查统�?

export const getFiveStarClassPublishAdminList = (params) => {
  return axios.get(`${base}/api/FiveStarClassPublishAdmin/GetList`, { params });
};

/** 校区下全部学期 + 发布快照（PC 首页看板） */

export const getFiveStarClassPublishAdminSemesterBoard = (params) => {
  return axios.get(`${base}/api/FiveStarClassPublishAdmin/GetSemesterBoard`, { params });
};

/** 编辑回显 */

export const getFiveStarClassPublishAdminForEdit = (params) => {
  return axios.get(`${base}/api/FiveStarClassPublishAdmin/GetForEdit`, { params });
};

/** 校区下可选班级 */

export const getFiveStarClassPublishAdminClassOptions = (params) => {
  return axios.get(`${base}/api/FiveStarClassPublishAdmin/GetClassOptionsUnderCampus`, { params });
};

/** 校区下按年级分组的行政班 */

export const getFiveStarClassPublishAdminGradeClassGroups = (params) => {
  return axios.get(`${base}/api/FiveStarClassPublishAdmin/GetGradeClassGroupsUnderCampus`, { params });
};

/** 保存发布 */

export const saveFiveStarClassPublishAdmin = (params) => {
  return axios.post(`${base}/api/FiveStarClassPublishAdmin/Save`, params);
};

/** 发布记录（分页） */

export const getFiveStarClassPublishAdminHistory = (params) => {
  return axios.get(`${base}/api/FiveStarClassPublishAdmin/GetHistory`, { params });
};

// 获取学生评分记录

export const getreturnoverduelist = (params) => {
  return axios.get(`${base}/api/teacher/getreturnoverduelist`, {
    params: params,
  });
};

// ================= SchoolSchedule 管理接口 =================
// 获取方案列表（分页）

export const getOrganizations = (params) => {
  return axios.get(`${base}/api/Organization/Get`, { params: params });
};

// 新增组织

export const addOrganization = (params) => {
  return axios.post(`${base}/api/Organization/Post`, params);
};

// 更新组织

export const updateOrganization = (params) => {
  return axios.post(`${base}/api/Organization/Put`, params);
};

// 删除组织

export const deleteOrganization = (params) => {
  return axios.delete(`${base}/api/Organization/Delete`, { params: params });
};

// 获取组织活动

export const getEvents = (params) => {
  return axios.get(`${base}/api/Organization/GetEvents`, { params: params });
};

// 按学生查询其参与的组织活动

export const getEventsByStudent = (params) => {
  return axios.get(`${base}/api/Organization/GetEventsByStudent`, { params: params });
};

/** 根据组织 Id 获取活动管理员候选项（教师主档，与组织管理员范围一致） */

export const getEventManagerCandidates = (params) => {
  return axios.get(`${base}/api/Organization/GetEventManagerCandidates`, {
    params: params,
  });
};

// 获取社团活动专业组类型
export const getProfessionalGroupTypes = (params) => {
  return axios.get(`${base}/api/Organization/GetProfessionalGroupTypes`, {
    params: params,
  });
};

// 新增社团活动专业组类型
export const addProfessionalGroupType = (data) => {
  return axios.post(`${base}/api/Organization/PostProfessionalGroupType`, data);
};

// 编辑社团活动专业组类型
export const updateProfessionalGroupType = (data) => {
  return axios.post(`${base}/api/Organization/PutProfessionalGroupType`, data);
};

// 删除社团活动专业组类型
export const deleteProfessionalGroupType = (params) => {
  return axios.post(`${base}/api/Organization/DeleteProfessionalGroupType`, null, {
    params: params,
  });
};

// 获取校区社团活动总览权限配置
export const getEventOverviewPermissions = (params) => {
  return axios.get(`${base}/api/Organization/GetEventOverviewPermissions`, { params: params });
};

// 保存校区社团活动总览权限配置
export const updateEventOverviewPermissions = (data) => {
  return axios.post(`${base}/api/Organization/PutEventOverviewPermissions`, data);
};

// 新增组织活动

export const addEvent = (params) => {
  return axios.post(`${base}/api/Organization/PostEvent`, params);
};

// 更新组织活动

export const updateEvent = (params) => {
  return axios.post(`${base}/api/Organization/PutEvent`, params);
};

// 删除组织活动

export const deleteEvent = (params) => {
  return axios.delete(`${base}/api/Organization/DeleteEvent`, {
    params: params,
  });
};

// 获取组织成员

export const getMembers = (params) => {
  return axios.get(`${base}/api/Organization/GetMembers`, { params: params });
};

// 根据班级 Id 获取该班所有节次的考勤统计

export const exportEventsExcel = (params) => {
  return axios.get(`${base}/api/Organization/ExportEventsExcel`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

// 按「校内活动-学生竞赛」表格模板导出（与活动列表筛选一致）。创建于 2026-10-28
export const exportCompetitionEventsExcel = (params) => {
  return axios.get(`${base}/api/Organization/ExportCompetitionEventsExcel`, {
    params: params,
    responseType: "blob",
  });
};

// 导出日点名统计：总节次、已点名节次数、未点名节次明细（含科目、教师）

export const getSemesterWeeksByClassId = (params) => {
  return axios.get(`${base}/api/Common/GetSemesterWeeksByClassId`, {
    params: params,
  });
};

// 根据学期 Id 获取周次

export const getSemesterWeeksBySemesterId = (params) => {
  return axios.get(`${base}/api/Common/GetSemesterWeeksBySemesterId`, {
    params: params,
  });
};



// 获取德育配置

export const getMoreDianConfig = (params) => {
  return axios.get(`${base}/api/MoreDian/GetConfig`, { params: params }).then((res) => res.data);
};

export const saveMoreDianConfig = (params, data) => {
  return axios.post(`${base}/api/MoreDian/SaveConfig`, data, { params: params }).then((res) => res.data);
};

export const getMoreDianDevices = (params) => {
  return axios.get(`${base}/api/MoreDian/GetDevices`, { params: params }).then((res) => res.data);
};
/** 魔点通行记录分页 */

export const getMoreDianAccessRecords = (params) => {
  return axios.get(`${base}/api/MoreDian/GetAccessRecords`, { params: params }).then((res) => res.data);
};

export const syncMoreDianDevices = (params) => {
  return axios.get(`${base}/api/MoreDian/SyncDevices`, { params: params }).then((res) => res.data);
};

export const updateMoreDianDeviceDirection = (params) => {
  return axios.post(`${base}/api/MoreDian/UpdateDeviceDirection`, null, { params: params }).then((res) => res.data);
};

export const registerMoreDianCallback = (params) => {
  return axios.post(`${base}/api/MoreDian/AddOrgCallback`, null, {
    params: params
  }).then((res) => res.data);
};

// 请假统计查看权限分组管理

export const getLeaveStatPermissionGroupList = (params) => {
  return axios.get(`${base}/api/LeaveStatPermissionGroup/GetList`, { params: params });
};

export const saveLeaveStatPermissionGroup = (params) => {
  return axios.post(`${base}/api/LeaveStatPermissionGroup/Save`, params);
};

export const deleteLeaveStatPermissionGroup = (params) => {
  return axios.delete(`${base}/api/LeaveStatPermissionGroup/Delete`, { params: params });
};
// 工作记录管理 (管理后台)
// 获取配置项列表

export const getWorkItemConfigList = (params) => {
  return axios.get(`${base}/api/WorkRecordAdmin/GetConfigs`, { params: params });
};
// 保存配置项 (新增/修改)

export const saveWorkItemConfig = (params) => {
  return axios.post(`${base}/api/WorkRecordAdmin/SaveConfig`, params);
};
// 删除配置项

export const removeWorkItemConfig = (params) => {
  return axios.post(`${base}/api/WorkRecordAdmin/DeleteConfig`, null, { params: params });
};
// 获取工作记录列表 (管理端汇总)

export const getWorkRecordList = (params) => {
  return axios.get(`${base}/api/WorkRecordAdmin/GetRecordList`, { params: params });
};
// 工作记录统计（按教师汇总）
export const getWorkRecordStatistics = (params) => {
  return axios.get(`${base}/api/WorkRecordAdmin/GetRecordStatistics`, { params: params });
};
// 导出工作记录统计（按教师汇总）
export const exportWorkRecordStatistics = (params) => {
  return axios.get(`${base}/api/WorkRecordAdmin/ExportRecordStatistics`, { params: params, responseType: "blob" });
};
// 导出工作记录

export const exportWorkRecordList = (params) => {
  return axios.get(`${base}/api/WorkRecordAdmin/ExportWorkRecordList`, { params: params, responseType: "blob" });
};

// ────────── 特殊课程管理 ──────────

// 特殊课程时间

export const getCommRuleListPage = (params) => axios.get(`${base}/api/CommRule/GetListPage`, { params });

export const getCommRuleOptions = (params) => axios.get(`${base}/api/CommRule/GetOptions`, { params });

export const saveCommRule = (params) => axios.post(`${base}/api/CommRule/Save`, params);

export const deleteCommRule = (params) => axios.post(`${base}/api/CommRule/Delete`, null, { params });

export const setCommRuleEnabled = (params) => axios.post(`${base}/api/CommRule/SetEnabled`, null, { params });

export const exportCommRules = (params) => axios.get(`${base}/api/CommRule/Export`, { params, responseType: "blob" });

export const getCommCallConfig = (params) => axios.get(`${base}/api/CommConfig/GetCallConfig`, { params });

export const saveCommCallConfig = (params) => axios.post(`${base}/api/CommConfig/SaveCallConfig`, params);

/** 微信 VOIP 通信组。创建于 2026-08-07 */
export const getCommVoipGroupList = (params) => axios.get(`${base}/api/CommVoipGroup/GetList`, { params });
export const getCommVoipEnabledGroups = (params) => axios.get(`${base}/api/CommVoipGroup/GetEnabledGroups`, { params });
export const getCommVoipGroupDetail = (params) => axios.get(`${base}/api/CommVoipGroup/GetDetail`, { params });
export const getCommVoipGroupDeviceList = (params) => axios.get(`${base}/api/CommVoipGroup/GetDeviceList`, { params });
export const createCommVoipGroup = (params) => axios.post(`${base}/api/CommVoipGroup/Create`, params);
export const updateCommVoipGroup = (params) => axios.post(`${base}/api/CommVoipGroup/Update`, params);
export const getCommVoipCandidateDevices = (params) => axios.get(`${base}/api/CommVoipGroup/GetCandidateDevices`, { params });
export const bindCommVoipDevices = (params) => axios.post(`${base}/api/CommVoipGroup/BindDevices`, params);
export const unbindCommVoipDevices = (params) => axios.post(`${base}/api/CommVoipGroup/UnbindDevices`, params);
export const registerCommVoipDevices = (params) => axios.post(`${base}/api/CommVoipGroup/RegisterDevices`, params);
export const getCommVoipParentAuthList = (params) => axios.get(`${base}/api/CommVoipGroup/GetParentAuthList`, { params });
export const getCommVoipParentAuthByParentId = (params) => axios.get(`${base}/api/CommVoipGroup/GetParentAuthByParentId`, { params });
export const getCommVoipParentVoipGroups = (params) => axios.get(`${base}/api/CommVoipGroup/GetParentVoipGroups`, { params });

/** 话机终端可扣费套餐（规则）绑定。创建于 2026-05-13 */

export const batchRestoreCommRuleBinding = (params) => axios.post(`${base}/api/CommRuleBinding/BatchRestoreBinding`, params);

export const exportCommRuleUsers = (params) => axios.get(`${base}/api/CommRuleBinding/Export`, { params, responseType: "blob" });

export const importCommRuleUsers = (formData) =>
  axios.post(`${base}/api/CommRuleBinding/Import`, formData, { headers: { "Content-Type": "multipart/form-data" } });

export const getCommBindLogListPage = (params) => axios.get(`${base}/api/CommBindLog/GetListPage`, { params });

export const exportCommBindLogs = (params) => axios.get(`${base}/api/CommBindLog/Export`, { params, responseType: "blob" });

export const getCommRuleQuotaListPage = (params) => axios.get(`${base}/api/CommRuleQuota/GetListPage`, { params });

export const getCommBindingQuotaPage = (params) => axios.get(`${base}/api/CommRuleQuota/GetBindingQuotaPage`, { params });

export const exportCommRuleQuota = (params) => axios.get(`${base}/api/CommRuleQuota/Export`, { params, responseType: "blob" });

export const getDingTalkPcSchoolMenuCatalog = () => axios.get(`${base}/api/DingTalkPcSchoolMenu/GetCatalog`);

export const getDingTalkPcSchoolMenuBySchool = (params) => axios.get(`${base}/api/DingTalkPcSchoolMenu/GetBySchool`, { params });

export const saveDingTalkPcSchoolMenu = (params) => axios.post(`${base}/api/DingTalkPcSchoolMenu/Save`, params);

export const resetDingTalkPcSchoolMenu = (params) => axios.post(`${base}/api/DingTalkPcSchoolMenu/ResetBySchool`, params);

export const publishScreenConfigAdmin = (params) => axios.post(`${base}/api/ScreenConfigAdmin/PublishConfig`, params);

export const getScreenRuntimeConfigAdmin = (params) => axios.get(`${base}/api/ScreenConfigAdmin/GetRuntimeConfig`, { params });

export const getScreenConfigHistoryAdmin = (params) => axios.get(`${base}/api/ScreenConfigAdmin/GetConfigHistory`, { params });

export const deleteScreenConfigHistoryAdmin = (params) => axios.post(`${base}/api/ScreenConfigAdmin/DeleteConfigHistory`, null, { params });

// ════════════════════════════════════════════════════════════════
//  哲商德育班级池（MoralZheshangH5Controller）
//  本文件封装供 PC Web 后台使用：不传 dutyStaffTeacherId（与后台同一套登录态，后端认 HttpContext.User 已认证）。
//  手机/H5 匿名访问须传 dutyStaffTeacherId（教师任教 Id），后端据此校验 DutyStaff。
// ════════════════════════════════════════════════════════════════

/** 获取全校班级池账户列表 */

export const adminGetFlagRecords = (params) =>
    axios.get(`${base}/api/FlowingRedFlagAdmin/GetFlagRecords`, { params });

/** 学期周次列表。PC 已登录不传 dutyStaffTeacherId；手机端须传。 */

export const adminGetSemesterWeeks = (params) =>
    axios.get(`${base}/api/FlowingRedFlagAdmin/GetSemesterWeeks`, { params });

// ════════════════════════════════════════════════════════════════
//  班级积分抽奖后台管理接口（ClassLotteryAdminController）
// ════════════════════════════════════════════════════════════════

/** 获取班级抽奖配置（只读） */

export const getMeetingRoomListPage = (params) =>
  axios.get(`${base}/api/MeetingRoom/GetList`, { params });

export const getMeetingRoomDetail = (id) =>
  axios.get(`${base}/api/MeetingRoom/GetDetail`, { params: { id } });

export const addMeetingRoom = (params) =>
  axios.post(`${base}/api/MeetingRoom/Post`, params);

export const editMeetingRoom = (params) =>
  axios.put(`${base}/api/MeetingRoom/Put`, params);

export const deleteMeetingRoom = (id) =>
  axios.delete(`${base}/api/MeetingRoom/Delete`, { params: { id } });

export const bindMeetingRoomCplate = (params) =>
  axios.post(`${base}/api/MeetingRoom/BindCplateTerminals`, params);

export const getMeetingBookingListPage = (params) =>
  axios.get(`${base}/api/MeetingBooking/GetList`, { params });

export const getMeetingBookingDetail = (id) =>
  axios.get(`${base}/api/MeetingBooking/GetDetail`, { params: { id } });

export const createMeetingBooking = (params) =>
  axios.post(`${base}/api/MeetingBooking/Create`, params);

export const searchMeetingBookingParticipants = (params) =>
  axios.get(`${base}/api/MeetingBooking/SearchParticipants`, { params });

export const cancelMeetingBooking = (bookingId) =>
  axios.post(`${base}/api/MeetingBooking/Cancel`, null, { params: { bookingId } });

export const approveMeetingBooking = (params) =>
  axios.post(`${base}/api/MeetingBooking/Approve`, params);

export const rejectMeetingBooking = (params) =>
  axios.post(`${base}/api/MeetingBooking/Reject`, params);

export const getMeetingBookingTimeline = (params) =>
  axios.get(`${base}/api/MeetingBooking/GetTimeline`, { params });

export const quickCreateMeetingBooking = (params) =>
  axios.post(`${base}/api/MeetingBooking/QuickCreate`, params);

export const getMeetingBookingPendingParticipation = (params) =>
  axios.get(`${base}/api/MeetingBooking/PendingParticipation`, { params });

export const getMeetingBookingQr = (bookingId) =>
  axios.get(`${base}/api/MeetingBooking/GetBookingQr`, { params: { bookingId } });

export const exportMeetingBooking = (params) =>
  axios.get(`${base}/api/MeetingBooking/Export`, { params, responseType: 'blob' });

export const getMeetingRoomQr = (roomId) =>
  axios.get(`${base}/api/MeetingRoom/GetRoomQr`, { params: { roomId } });

export const getMeetingRoomDashboardStats = (params) =>
  axios.get(`${base}/api/MeetingRoomDashboard/GetStats`, { params });

export const getMeetingRoomDashboardUtilization = (params) =>
  axios.get(`${base}/api/MeetingRoomDashboard/GetUtilization`, { params });

export const getMeetingRoomDashboardTrend = (params) =>
  axios.get(`${base}/api/MeetingRoomDashboard/GetTrend`, { params });

export const createMeetingRecurringBooking = (params) =>
  axios.post(`${base}/api/MeetingBooking/CreateRecurring`, params);

export const cancelMeetingRecurringBooking = (recurringId) =>
  axios.post(`${base}/api/MeetingBooking/CancelRecurring`, null, { params: { recurringId } });

export const getMeetingBookingSignIns = (bookingId) =>
  axios.get(`${base}/api/MeetingBooking/GetSignIns`, { params: { bookingId } });

export const checkInMeetingBooking = (params) =>
  axios.post(`${base}/api/MeetingBooking/CheckIn`, params);

export const getMeetingRecurringSeriesList = (params) =>
  axios.get(`${base}/api/MeetingBooking/GetRecurringSeriesList`, { params });

export const exportMeetingSignInReport = (params) =>
  axios.get(`${base}/api/MeetingBooking/ExportSignInReport`, { params, responseType: 'blob' });

export const getMeetingRoomSchoolConfig = (schoolId) =>
  axios.get(`${base}/api/MeetingRoom/GetSchoolConfig`, { params: { schoolId } });

export const saveMeetingRoomSchoolConfig = (params) =>
  axios.post(`${base}/api/MeetingRoom/SaveSchoolConfig`, params);

// ================== 用户个性化配置中心接口 ==================
// 保存用户配置 (增/改)

export const saveUserConfig = (params) =>
  axios.post(`${base}/api/UserConfig/SaveConfig`, params);

// 获取用户特定的配置值

export const getUserConfig = (params) =>
  axios.get(`${base}/api/UserConfig/GetConfig`, { params });

// 保存全局系统配置（与 userId 无关，超级管理员写入，全体用户共享读取）

export const saveGlobalConfig = (params) =>
  axios.post(`${base}/api/UserConfig/SaveGlobalConfig`, params);

// 获取全局系统配置（与 userId 无关）

export const getGlobalConfig = (params) =>
  axios.get(`${base}/api/UserConfig/GetGlobalConfig`, { params });
